import { render } from "./user_panel.vue?vue&type=template&id=460aaa4a"
import script from "./user_panel.js?vue&type=script&lang=js&external"
export * from "./user_panel.js?vue&type=script&lang=js&external"

import "./user_panel.vue?vue&type=style&index=0&id=460aaa4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__